import type { PathPart } from '@cli-types/next-adapter/forms.js'
import { pathExpression } from './path-expression.js'

export function pathNameProp(path: PathPart[]): string {
  if (path.every((part) => typeof part === 'string')) {
    return `"${path.map((part) => part as string).join('.')}"`
  }
  return `{${pathExpression(path)}}`
}
